import { render } from "./BookingHelpBanner.vue?vue&type=template&id=3813a42b"
import script from "./BookingHelpBanner.vue?vue&type=script&lang=js"
export * from "./BookingHelpBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__